"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelemetryHelper = void 0;
var typescript_telemetry_forwarder_1 = require("@tableau/typescript-telemetry-forwarder");
var reselect_1 = require("reselect");
var TelemetryConstants = require("./TelemetryConstants");
var TelemetryConstants_1 = require("./TelemetryConstants");
var getTelemetryForwarder = reselect_1.defaultMemoize(function () { return new typescript_telemetry_forwarder_1.TelemetryForwarder(); });
var TelemetryHelper = /** @class */ (function () {
    function TelemetryHelper() {
    }
    TelemetryHelper.addLogger = function (log) {
        TelemetryHelper.log = log;
    };
    TelemetryHelper.addOrUpdateTelemetry = function (key, value) {
        this.data[key] = value;
    };
    TelemetryHelper.addOrIncrementTelemetryCounter = function (telemetryKey) {
        var telemetryValue = TelemetryHelper.data[telemetryKey];
        if (!telemetryValue) {
            telemetryValue = 0;
        }
        if (typeof telemetryValue === 'number') {
            telemetryValue = telemetryValue + 1;
            TelemetryHelper.addOrUpdateTelemetry(telemetryKey, telemetryValue);
        }
        else {
            console.error("Invalid telemetry value " + telemetryValue + " - is not a number");
        }
    };
    TelemetryHelper.initSource = function (source) {
        var sourceName;
        var serviceName;
        switch (source) {
            case TelemetryConstants_1.SourceType.VizClientAuthoring:
                sourceName = TelemetryConstants_1.SourceName.VizClientAuthoring;
                serviceName = TelemetryConstants_1.ServiceName.VizClient;
                break;
            case TelemetryConstants_1.SourceType.VizClientViewing:
                sourceName = TelemetryConstants_1.SourceName.VizClientViewing;
                serviceName = TelemetryConstants_1.ServiceName.VizClient;
                break;
            case TelemetryConstants_1.SourceType.VizPortalClientWorkbook:
                sourceName = TelemetryConstants_1.SourceName.VizPortalClientWorkbook;
                serviceName = TelemetryConstants_1.ServiceName.VizPortalClient;
                break;
            case TelemetryConstants_1.SourceType.VizPortalClientView:
                sourceName = TelemetryConstants_1.SourceName.VizPortalClientView;
                serviceName = TelemetryConstants_1.ServiceName.VizPortalClient;
                break;
            default:
                sourceName = TelemetryConstants_1.SourceName.Unknown;
                serviceName = TelemetryConstants_1.ServiceName.Unknown;
        }
        TelemetryHelper.data[TelemetryConstants.InitatingSource] = sourceName;
        TelemetryHelper.service = serviceName;
    };
    TelemetryHelper.reportAndClearTelemetry = function (exitType) {
        TelemetryHelper.addOrUpdateTelemetry(TelemetryConstants.ExitType, exitType);
        this.sendAndClearData();
    };
    TelemetryHelper.reportErrorTelemetry = function () {
        TelemetryHelper.addOrUpdateTelemetry(TelemetryConstants.ExitType, TelemetryConstants.Error);
        this.sendAndClearData();
    };
    TelemetryHelper.sendAndClearData = function () {
        TelemetryHelper.data[TelemetryConstants.InitatingSource] =
            TelemetryHelper.data[TelemetryConstants.InitatingSource] || TelemetryConstants_1.SourceName.Unknown;
        TelemetryHelper.log(TelemetryConstants.EventType, TelemetryHelper.data);
        getTelemetryForwarder().buildTelemetryAndSend(TelemetryConstants.EventType, TelemetryHelper.service, TelemetryHelper.data);
        TelemetryHelper.data = {};
    };
    TelemetryHelper.data = {};
    TelemetryHelper.service = TelemetryConstants_1.ServiceName.Unknown;
    return TelemetryHelper;
}());
exports.TelemetryHelper = TelemetryHelper;
//# sourceMappingURL=TelemetryHelper.js.map